import React from "react";
import { faCheckCircle, faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Button } from "react-bootstrap";

const ConfirmationPopUpCard = ({ setConfirmFund, setFlag }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "50px",
        border: "1px solid black",
        fontWeight: 500,
        fontSize: "18px",
        lineHeight: "24px",
        background:
          "linear-gradient(0deg, rgba(178, 205, 186, 0.3), rgba(178, 205, 186, 0.3)), #FEFEFE",
        borderRadius: "5px",
        padding: "10px 0px 10px 10px",
      }}
    >
      <FontAwesomeIcon icon={faCheckCircle} color="green" size="lg" />
      ACH Debit - Manually Confirmed
    </div>
  );
};

export default ConfirmationPopUpCard;
